<template>
    <div class="setup-ai-template-data-summary">
        <ParameterConfiguredBadge :configured="isConfigured" />

        <p
            v-if="isConfigured"
            class="text-main-xs text-gray-500 mt-1.5 line-clamp-2"
        >
            {{ summaryText }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ParameterConfiguredBadge
    from '@/components/RedesignComponents/Widgets/Parameters/ParameterConfiguredBadge.vue'
import { WidgetConfig } from '@/types/dashboard'
import { AI_PARAMETER_MODE, AiParameterValueJson } from '@/types/widgetParameters'
import i18n from '@/i18n'

const props = defineProps<{
    value: WidgetConfig
}>()

const valueJson = computed(() => {
    return props.value?.WidgetParameterValueJson as AiParameterValueJson | undefined
})

const isConfigured = computed(() => {
    const data = valueJson.value?.data
    if (Array.isArray(data)) {
        return !!data.length
    }
    return !!String(data ?? '').trim()
})

const modeLabel = computed(() => {
    const mode = valueJson.value?.type ?? AI_PARAMETER_MODE.SINGLE
    return i18n.t(`widget.ai.mode.${mode}`)
})

const details = computed(() => {
    const data = valueJson.value?.data
    if (Array.isArray(data)) {
        return data.join(', ')
    }
    return String(data ?? '').trim().slice(0, 120)
})

const summaryText = computed(() => {
    return details.value
        ? `${modeLabel.value}: ${details.value}`
        : String(modeLabel.value)
})
</script>
